import { ItemListView } from "@app/types";
import { createUuid } from "@app/utilities";
import BaseComponent from "./BaseComponent";
import Dropdown from "./Dropdown";
import OldItemList from "./OldItemList";
import OldInput from './OldInput';

export default class ExitComponent extends BaseComponent {
    /**
     * Component for exit node
     * @module ExitComponent
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.exitComponent = {};
    }

    /**
     * Set config proxy; change data model based on function type
     * @param {string} key
     * @param {Array|string} value
     */
    setConfig(key, value) {
        if (this.props.exitHandling === "HANGUP" || this.props.exitHandling === "ENDPOINT") {
            delete this.exitComponent.type;
            delete this.exitComponent.destination;
            delete this.exitComponent.customHeaders;
            delete this.exitComponent.handlingModule;
        }
        if (key === "destination" && (value !== undefined || value !== null) && value !== "") {

            var idx = window.apm.serialized.components.variables.findIndex(element => element.id === value);
            window.apm.serialized.components.variables[idx].props.usedIn.push(this.props.context.props.parentComponentID);
        }
        if (key === "destination" && this.props.context.props.config.exitComponent !== undefined && this.props.context.props.config.exitComponent["destination"] !== "" && value === "") {
            var idx = window.apm.serialized.components.variables.findIndex(element => element.id === this.props.context.props.config.exitComponent["destination"]);
            var exitIdx = window.apm.serialized.components.variables[idx].props.usedIn.findIndex(element => element === this.props.context.props.parentComponentID);
            window.apm.serialized.components.variables[idx].props.usedIn.splice(exitIdx, 1);
        }
        this.exitComponent[key] = value;
        this.updateContext(this.exitComponent);
        this.forceUpdate();
    }

    /**
     * Get current context value
     * @param {string} key
     * @returns {*}
     */
    getConfig(key) {
        return this.exitComponent[key];
    }

    componentWillMount() {
        if (this.props.value) {
            this.exitComponent = this.props.value;
        }
    }
    varOptions() {
        const varOptions = window.apm.getVariables();
        return varOptions.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }
    moduleOptions() {
        const isCommonModule = this.props.readOnly && this.props.context.props.moduleId !== undefined;
        if (!isCommonModule) {
            return window.apm.knowledgeBase.getModules();
        }
        else {
            if (isCommonModule) {
                const commonMod = window.apm.serialized.components.modules.find(mod => mod.id === this.props.context.props.moduleId);
                return window.apm.knowledgeBase.getCommonModulesOptions(commonMod);
            }
        }
    }

    getHandOffClient(){
        return this.props.context.props.config.exitComponent && this.props.context.props.config.exitComponent.handOffClient 
            || ''
    }

    getHandOffApplication(){
        return this.props.context.props.config.exitComponent && this.props.context.props.config.exitComponent.handOffApplication || '';
    }

    getHandOffApplicationProperty(){
        return this.props.context.props.config.exitComponent && this.props.context.props.config.exitComponent.handOffVersion || '';
    }

    /**
     * React render
     * @returns {*}
     */
    render() {

        if (this.props.exitHandling === "ENDPOINT" ||
            this.props.exitHandling === "RETURN_TO_ROOT_MODULE" ||
            this.props.exitHandling === "RETURN_TO_PREVIOUS_MODULE" ||
            this.props.exitHandling === "RETURN_TO_PREVIOUS_INPUT") {
            return (<div />);
        } else if (this.props.exitHandling === "HAND_OFF") {
            var moduleSel = window.apm.knowledgeBase.getIndexFromValue(this.getConfig("callbackModule"), this.moduleOptions());
            
            return (
                <div>
                    <OldInput 
                        label={'Client'}
                        value={this.getHandOffClient()}
                        context={this}
                        valRules={{ "noEmpty": true }} 
                        valKey="handOffClient"
                    />

                    <OldInput 
                        label={'Application'}
                        context={this}
                        valRules={{ "noEmpty": true }}
                        valKey="handOffApplication" 
                        value={this.getHandOffApplication()}
                    />
                    <OldInput 
                        label={"Application Property"}
                        context={this}
                        valRules={{"noEmpty": true}}
                        valKey={"handOffVersion"}
                        value={this.getHandOffApplicationProperty()}/>

                    <Dropdown label={"Back from Hand Off"}
                        context={this}
                        valKey={"callbackModule"}
                        optionName={this.getPropLabel("session_ended_handling_module_opt")}
                        options={this.moduleOptions()}
                        selection={moduleSel}
                        removable={true}
                        readOnly={this.props.readOnly}
                    />
                </div>
            );
        } else if (this.props.exitHandling === "HANGUP") {
            const moduleSel = window.apm.knowledgeBase.getIndexFromValue(this.getConfig("handlingModule"), this.moduleOptions());
            return (
                <div>
                    <Dropdown label={this.getPropLabel("session_ended_handling_module")}
                        context={this}
                        valKey={"handlingModule"}
                        optionName={this.getPropLabel("session_ended_handling_module_opt")}
                        options={this.moduleOptions()}
                        selection={moduleSel}
                        removable={true}
                        readOnly={this.props.readOnly}
                    />
                </div>
            );
        } else if (this.props.exitHandling === "SUBDIALOG_RETURN") {
            return (
                <div>
                    <OldItemList label={this.getPropLabel("custom_headers")}
                        view={ItemListView.keyValue}
                        context={this}
                        valKey={"customHeaders"}
                        value={this.getConfig("customHeaders")}
                        allowDelete={true}
                        readOnly={this.props.readOnly}
                    />
                    <Dropdown label={this.getPropLabel("session_ended_handling_module")}
                        context={this}
                        valKey={"handlingModule"}
                        optionName={this.getPropLabel("session_ended_handling_module_opt")}
                        options={this.moduleOptions()}
                        selection={moduleSel}
                        removable={true}
                        readOnly={this.props.readOnly}
                    />
                </div>
            );
        } 
        //update the property panel to show channel type drop down and option to add conversation variables ehen exit handle selection is channel end
        else if (this.props.exitHandling === "CHANNEL_END") {
            const { channelNameOptions } = window.apm.getChannelOptions();
            let { channelType: channelName } = this.props.context.props.config.exitComponent;
            const selectedChannel = channelNameOptions.findIndex(({ value }) => {
                return value === channelName;
            });

            return (
                <div>
                    <Dropdown label={this.getPropLabel("channel_type")}
                        context={this}
                        valKey={"channelType"}
                        optionName={this.getPropLabel("channel_type_opt")}
                        options={channelNameOptions}
                        selection={selectedChannel}
                        readOnly={this.props.readOnly}
                    />
                    <OldItemList label={this.getPropLabel("conversational_variables")}
                        context={this}
                        view={ItemListView.keyValue}
                        keyType="conversationVariable"
                        valKey={"conversationVariables"}
                        value={this.getConfig("conversationVariables")}
                        allowDelete={true}
                        readOnly={this.props.readOnly}
                        suggestion={"variable"}
                    />
                </div>
            )
        }else { // TRANSFER
            const moduleSel = window.apm.knowledgeBase.getIndexFromValue(this.getConfig("handlingModule"), this.moduleOptions());
            const typeOptions = [
                { name: "SIP", value: "SIP" },
                { name: "TNT", value: "TNT" },
                { name: "TROMBONE", value: "TROMBONE" }
            ];
            var typeSel = -1;
            for (var i = 0; i < typeOptions.length; i++) {
                if (typeOptions[i].value === this.getConfig("type")) {
                    typeSel = i;
                }
            }

            var varSel = -1;
            for (var i = 0; i < this.varOptions().length; i++) {
                if (this.varOptions()[i].value === this.getConfig("destination")) {
                    varSel = i;
                }
            }

            return (
                <div>
                    <Dropdown key={createUuid()}
                        label={this.getPropLabel("type")}
                        context={this}
                        valKey={"type"}
                        optionName={this.getPropLabel("select_type")}
                        options={typeOptions}
                        selection={typeSel}
                        readOnly={this.props.readOnly}
                    />
                    <Dropdown label={this.getPropLabel("destination")}
                        optionName={this.getPropLabel("destination")}
                        context={this}
                        valKey={"destination"}
                        options={this.varOptions()}
                        selection={varSel}
                        removable={true}
                        readOnly={this.props.readOnly}
                    />
                    <OldItemList label={this.getPropLabel("custom_headers")}
                        view={ItemListView.keyValue}
                        context={this}
                        valKey={"customHeaders"}
                        value={this.getConfig("customHeaders")}
                        allowDelete={true}
                        readOnly={this.props.readOnly}
                    />
                    <Dropdown label={this.getPropLabel("session_ended_handling_module")}
                        context={this}
                        valKey={"handlingModule"}
                        optionName={this.getPropLabel("session_ended_handling_module_opt")}
                        options={this.moduleOptions()}
                        selection={moduleSel}
                        removable={true}
                        readOnly={this.props.readOnly}
                    />
                </div>
            );
        }
    }
}
